import { Button, ProgressLoader, Title } from '@components/ui';
import { AppRoutes } from '@types';
import DataCollectionCompletedIllustration from 'public/illustrations/data-collection-completed.svg';

import styles from './Steps.module.scss';

interface CompleteProps {
  isLongAssessment?: boolean;
  onStartNew?: () => void;
}

export const Complete: React.FC<CompleteProps> = ({ isLongAssessment = false, onStartNew }) => (
  <div className={styles.completeContainer}>
    <div>
      <DataCollectionCompletedIllustration />
    </div>
    <div className={styles.textWrapper}>
      <Title
        htmlElement="h2"
        className={styles.completeTitle}
      >
        {!isLongAssessment ? 'Well done!' : 'We will notify you later!'}
      </Title>
      <p>
        {!isLongAssessment
          ? 'You have successfully submitted your questionnaire answers!'
          : 'Assessments for submitted questionnaire is taking more time then usual, we will notify you as soon as we finish with calculations.'}
      </p>
      {!isLongAssessment && (
        <p>
          We are currently running the assessment which may take some time. We will notify you when the calculations are
          done.
        </p>
      )}
      {!isLongAssessment && <ProgressLoader className={styles.completeLoader} />}

      {isLongAssessment && (
        <div className={styles.completeButtons}>
          <Button
            onClick={onStartNew}
            type="button"
          >
            Start new assessment
          </Button>
          <Button
            link={{ url_label: 'Go to assessment log', url: AppRoutes.assessmentInventory }}
            type="button"
          />
        </div>
      )}
    </div>
  </div>
);
